import * as React from 'react';
import { Link as ReactRouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  link: {
    color: theme.palette.primary.light,
    '&:hover': {
      color: theme.palette.primary.main
    }
  }
});

type FixedNavLinkProps = Omit<RouterLinkProps, 'innerRef'>;

type Props = WithStyles<typeof styles> & Partial<FixedNavLinkProps>;

const LinkComponent = React.forwardRef<any, Props>(({ classes, to, ...props }, ref) =>
  to ? (
    <ReactRouterLink ref={ref} className={classes.link} to={to} {...props} />
  ) : (
    <a ref={ref} className={classes.link} {...props}>
      {props.children}
    </a>
  )
);

export const Link = withStyles(styles)(LinkComponent);
